import { Typography, Button, Container, Paper } from "@mui/material";
import { styled } from "@mui/system";
import { MdDashboard } from "react-icons/md";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ErrorContainer = styled(Container)(() => ({
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "2rem",
}));

const ErrorContent = styled(Paper)(() => ({
  padding: "3rem",
  textAlign: "center",
  borderRadius: "16px",
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
  background: "rgba(255, 255, 255, 0.95)",
  backdropFilter: "blur(10px)",
  transition: "transform 0.3s ease",
  "&:hover": {
    transform: "translateY(-5px)",
  },
}));

const ErrorNumber = styled(Typography)(() => ({
  fontSize: "8rem",
  fontWeight: 700,
  color: "#2d3436",
  marginBottom: "1rem",
  background: "linear-gradient(45deg, #2d3436 30%, #636e72 90%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
}));

const ActionButton = styled(Button)(() => ({
  margin: "1rem",
  padding: "0.75rem 2rem",
  borderRadius: "8px",
  textTransform: "none",
  fontSize: "1rem",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  },
}));

const ErrorPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <ErrorContainer maxWidth="lg">
      <ErrorContent elevation={0}>
        <Grid container spacing={3} justifyContent="center">
          <Grid size={12}>
            <ErrorNumber variant="h1">404</ErrorNumber>
            <Typography
              variant="h4"
              gutterBottom
              sx={{ fontWeight: 600, color: "#2d3436" }}
            >
              {t("notFound.title")}
            </Typography>
            <Typography variant="body1" color="textSecondary" paragraph>
              {t("notFound.description")}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {t("notFound.errorReference")}
            </Typography>
          </Grid>

          <Grid size={12}>
            <ActionButton
              variant="contained"
              color="primary"
              startIcon={<MdDashboard />}
              aria-label={t("notFound.returnHomeAria")}
              onClick={() => navigate("/")}
            >
              {t("notFound.returnHomeButton")}
            </ActionButton>
          </Grid>
        </Grid>
      </ErrorContent>
    </ErrorContainer>
  );
};

export default ErrorPage;
